import { render, staticRenderFns } from "./DetailsActionExtraPayment.vue?vue&type=template&id=6404f536"
import script from "./DetailsActionExtraPayment.vue?vue&type=script&lang=js"
export * from "./DetailsActionExtraPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports